module.exports = __webpack_public_path__ + "img/bg-vhub-login.7cb567f8.jpg";